<template>
  <div class="rights">
    <el-dialog title="添加权限" :visible.sync="outerVisible">
      <el-row :gutter="0">
        <el-form
          ref="addRights"
          :model="formData"
          :rules="rules"
          size="medium"
          label-width="100px"
        >
          <el-col :span="24">
            <el-form-item label="权限" prop="name">
              <el-select
                v-model="formData.name"
                placeholder="请选择下拉选择"
                clearable
                :style="{ width: '100%' }"
              >
              <el-option
                v-for="val in guardOptions"
                :key="val"
                :label="val"
                :value="val"
              ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">取 消</el-button>
        <el-button type="primary" @click="addRightsComfirm('addRights')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- Form -->
    <el-dialog title="用户权限管理" :visible.sync="rightsVisible">
      <el-table :data="userRightsList" border :stripe="true" style="width: 100%" max-height="600">
        <el-table-column prop="name" label="权限名"> </el-table-column>
        <el-table-column prop="created_at" label="创建日期"> </el-table-column>
        <el-table-column prop="updated_at" label="最近更新日期"> </el-table-column>
        <el-table-column width="100">
          <template slot-scope="scope">
            <el-button
              plain
              type="danger"
              size="small"
              @click="delUserRights(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-row>
          <el-col :span="8">
            <el-row>
              <el-col :span="10">用户：{{user.name}}</el-col>
              <el-col :span="14">权限分配：</el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-radio-group v-model="radio">
              <el-radio :label="item.id" v-for="item in rightsData">{{item.name}}</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4">
            <el-button type="success" @click="putUserRights">添 加</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-card>
      <div class="function clearfix">
        <div class="fr bnt">
          <el-button  type="success" @click="addRights">添加权限</el-button>
        </div>
      </div>
      <el-table :data="rightsData" border :stripe="true" style="width: 100%" max-height="600">
        <el-table-column prop="name" label="权限名"> </el-table-column>
        <el-table-column prop="created_at" label="创建日期"> </el-table-column>
        <el-table-column prop="updated_at" label="最近更新日期"> </el-table-column>
        <el-table-column width="100">
          <template slot-scope="scope">
            <el-button
              plain
              type="danger"
              size="small"
              @click="delRightsSub(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <div class="userRights">
      <el-divider content-position="left"><em>用户权限分配</em></el-divider>
      <el-card>
      <el-table :data="usersData" border :stripe="true" style="width: 100%" max-height="600">
        <el-table-column prop="name" label="用户名"> </el-table-column>
        <el-table-column prop="created_at" label="创建日期"> </el-table-column>
        <el-table-column prop="updated_at" label="最近更新日期"> </el-table-column>
        <el-table-column width="120">
          <template slot-scope="scope">
            <el-button
              type="success"
              plain
              size="small"
              @click="getUserRights(scope.row)"
              >修改权限</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        radio: 0, // 权限下标
        rightsData: [], // 权限列表
        outerVisible: false, // 添加权限弹窗
        rightsVisible: false, // 添加权限弹窗
        formData: { // 添加表单数据
          id: 1,
          name: "",
          guard_name: "",
          created_at: "2020-11-26 10:47:45",
          updated_at: "2020-11-26 10:47:45"
        },
        rules: {
          name: [
            {
              required: true,
              message: "请输入权限名(不能为空）",
              trigger: "blur",
            },
          ],
          guard_name: [
            {
              required: true,
              message: "请输入所属组名(不能为空）",
              trigger: "blur",
            },
          ],
        },
        guardOptions: ["实时监控", "排产统计", "生产计划", "用户管理"], // 所属组名
        usersData: undefined, // 用户列表数据
        userRightsList: undefined, // 用户所有权限数据
        user: {name: ''}, // 用户
      }
    },
    created() {
      this.getRights(); // 获取权限列表数据
      this.getUser(); // 获取所有用户
    },
    methods: {
      // -----------------------------------request-----------start

      // 获取权限列表数据
      async getRights(){
        const {data: res } = await this.axios.get("/rights");
        this.rightsData = res.data.right;
        if(res.meta.status !== 200) return this.$message.warning("请求异常");
      },
      // 添加权限
      async postRights(){
        const {data: res } = await this.axios.post("/rights", {name: this.formData.name});
        if(res.meta.status === 200 || res.meta.status === 409) {
          this.getRights();
          return this.$message.success(res.meta.msg);
        }
        return this.$message.error("请求异常！！！");
      },
      // 删除权限
      async delRights(row){
        const {data: res } = await this.axios.delete("/rights", {params: {id: row.id}});
        if(res.meta.status === 200) {
          this.getRights();
          return this.$message.success(res.meta.msg);
        }
      },
      // 获取所有用户
      async getUser() {
        const { data: res } = await this.axios.get("/users");
        if (res.meta.status === 200) {
          this.usersData = res.data.users;
        }else{
          this.$message.warning("获取用户失败！！！");
        }
      },
      // 分配用户权限
      async putUserRights(){
        const { data: res } = await this.axios.put(`/users/${this.user.id}/rights`, {rid: this.radio});
        if (res.meta.status === 200) {
          this.$message.success(res.meta.msg);
          this.getUserRights(this.user);
        }else{
          this.$message.warning("请求异常！！！");
        }
      },
      // 获取指定用户数据
      async getUserRights(row){
        this.user = row;
        const { data: res } = await this.axios.get(`/users/${row.id}/rights`);
        if(res.meta.status === 200){
          this.rightsVisible = true;
          this.userRightsList = res.data;
          // console.log(this.userRightsList)
        }else{
          this.$message.error("请求异常！！！");
        }
      },
      // 删除用户指定权限
      async delUserRights(index, row){
        const {data: res } = await this.axios.delete(`/users/${this.user.id}/rights`, {params: {rid: row.id}});
        if(res.meta.status === 200){
          this.getUserRights(this.user);
          this.$message.success(res.meta.msg);
        }else{
          this.$message.error("操作失败！！！");
        }
      },

      // -----------------------------------request-----------end

      // 添加权限
      addRights(){
        this.outerVisible = true;
      },

      // 确定添加权限
      addRightsComfirm(formName){
        this.$refs[formName].validate((valid) => {
          if(valid){
            this.postRights();
          }
        });
      },
      // 删除权限
      delRightsSub(index, row){
        this.$alert('是否确定删除？', '确认操作', {
          confirmButtonText: '确定',
          callback: action => {
            if(action === 'confirm'){
              this.delRights(row); // 确定删除用户
            }
          }
        });
      },
    }
  }
</script>

<style lang="less" scoped>

</style>